var _path, _rect, _path2, _circle, _rect2, _path3, _path4, _path5, _path6, _path7, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaterHeaterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 340 340",
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M67.236 227.356h13.927v101.813H67.236zM199.263 327.179a66.416 66.416 0 0 1-66.341-66.341v-33.482h13.927v33.482a52.414 52.414 0 1 0 104.828 0V165.2H265.6v95.637a66.416 66.416 0 0 1-66.337 66.342Z",
    className: "colorfff svgShape"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 133.012,
    height: 202.607,
    x: 40.537,
    y: 10.831,
    fill: "#ffffff",
    rx: 17.76,
    className: "colorfff svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9bacbf",
    d: "M130.178 186.432H83.907a12.691 12.691 0 0 0-12.691 12.691v14.315h71.653v-14.315a12.691 12.691 0 0 0-12.691-12.691Z",
    className: "color9bacbf svgShape"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 107.043,
    cy: 137.322,
    r: 22.061,
    fill: "#dfe3ea",
    className: "colordfe3ea svgShape"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 17.759,
    height: 15.188,
    x: 57.195,
    y: 156.688,
    fill: "#9bacbf",
    rx: 2.516,
    className: "color9bacbf svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9bacbf",
    d: "M135.233 74.749a84.7 84.7 0 0 1-56.38 0 9.007 9.007 0 0 1-6.082-8.518v-6.982h68.544v6.982a9.007 9.007 0 0 1-6.082 8.518Z",
    className: "color9bacbf svgShape"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3c3e4f",
    d: "M58.909 213.438h30.583v13.136a6.455 6.455 0 0 1-6.455 6.455H65.364a6.455 6.455 0 0 1-6.455-6.455v-13.136zm65.685 0h30.583v13.136a6.455 6.455 0 0 1-6.455 6.455h-17.673a6.455 6.455 0 0 1-6.455-6.455v-13.136z",
    className: "color3c3e4f svgShape"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#9bacbf",
    d: "M251.677 143.086h13.927v29.203h-13.927z",
    className: "color9bacbf svgShape"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M258.141 153.244a13.934 13.934 0 0 1-13.934-13.934V84.3h27.868v55.01a13.933 13.933 0 0 1-13.934 13.934Z",
    className: "colorfff svgShape"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#9bacbf",
    d: "m244.207 103.203 27.868 12.865V84.295h-27.868v18.908z",
    className: "color9bacbf svgShape"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 258.141,
    cy: 52.153,
    r: 41.322,
    fill: "#ffffff",
    className: "colorfff svgShape"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 258.141,
    cy: 52.153,
    r: 26.82,
    fill: "#9bacbf",
    className: "color9bacbf svgShape"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 258.141,
    cy: 52.153,
    r: 3.482,
    fill: "#3c3e4f",
    className: "color3c3e4f svgShape"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 258.141,
    cy: 38.91,
    r: 3.482,
    fill: "#3c3e4f",
    className: "color3c3e4f svgShape"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 258.141,
    cy: 65.395,
    r: 3.482,
    fill: "#3c3e4f",
    className: "color3c3e4f svgShape"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 271.384,
    cy: 52.153,
    r: 3.482,
    fill: "#3c3e4f",
    className: "color3c3e4f svgShape"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 244.899,
    cy: 52.153,
    r: 3.482,
    fill: "#3c3e4f",
    className: "color3c3e4f svgShape"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#3c3e4f",
    d: "M199.263 330.661a69.9 69.9 0 0 0 69.823-69.823v-108a17.387 17.387 0 0 0 6.471-13.529V93.433a44.8 44.8 0 1 0-34.832 0v45.878a17.4 17.4 0 0 0 7.47 14.276v107.251a48.932 48.932 0 0 1-97.864 0V236.37a9.946 9.946 0 0 0 8.327-9.8v-9.87a21.258 21.258 0 0 0 18.372-21.025V28.592a21.267 21.267 0 0 0-21.241-21.243H58.3a21.267 21.267 0 0 0-21.245 21.243v167.086A21.258 21.258 0 0 0 55.427 216.7v9.872a9.946 9.946 0 0 0 8.327 9.8v92.8a3.483 3.483 0 0 0 3.482 3.482h13.928a3.482 3.482 0 0 0 3.481-3.482v-92.8a9.945 9.945 0 0 0 8.329-9.8v-9.652h28.138v9.655a9.945 9.945 0 0 0 8.328 9.8v24.468a69.9 69.9 0 0 0 69.823 69.818ZM220.3 52.152a37.84 37.84 0 1 1 37.84 37.841 37.883 37.883 0 0 1-37.84-37.841Zm27.388 43.561a44.53 44.53 0 0 0 20.9 0v43.6a10.452 10.452 0 1 1-20.9 0Zm-48.425 221.021a55.959 55.959 0 0 0 55.895-55.9V156.452a16.618 16.618 0 0 0 6.964-.2v104.586a62.86 62.86 0 0 1-125.719 0v-24.326h6.964v24.326a55.96 55.96 0 0 0 55.896 55.896ZM44.019 195.678V28.592A14.294 14.294 0 0 1 58.3 14.313h97.492a14.294 14.294 0 0 1 14.278 14.279v167.086a14.294 14.294 0 0 1-14.278 14.278h-9.437v-10.833a16.192 16.192 0 0 0-16.174-16.173H83.907a16.191 16.191 0 0 0-16.173 16.173v10.833H58.3a14.294 14.294 0 0 1-14.281-14.278ZM74.7 209.956v-10.833a9.22 9.22 0 0 1 9.21-9.209h46.271a9.22 9.22 0 0 1 9.21 9.209v10.833Zm-3.982 115.731v-89.175h6.964v89.175Zm15.292-99.112a2.976 2.976 0 0 1-2.973 2.973H65.364a2.976 2.976 0 0 1-2.974-2.973v-9.655h23.62Zm42.066 0v-9.655H151.7v9.655a2.976 2.976 0 0 1-2.974 2.973h-17.677a2.976 2.976 0 0 1-2.973-2.973Z",
    className: "color3c3e4f svgShape"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#3c3e4f",
    d: "M107.043 111.78a3.482 3.482 0 0 0-3.482 3.481v22.061a3.482 3.482 0 0 0 6.964 0v-18.24a18.565 18.565 0 1 1-15.3 3.9 3.482 3.482 0 0 0-4.432-5.371 25.544 25.544 0 1 0 16.249-5.833zm-38.281 63.578a9.685 9.685 0 0 0 9.674-9.674v-2.8a9.685 9.685 0 0 0-9.674-9.674h-5.375a9.685 9.685 0 0 0-9.674 9.674v2.8a9.685 9.685 0 0 0 9.674 9.674zm-8.085-9.674v-2.8a2.714 2.714 0 0 1 2.71-2.711h5.375a2.714 2.714 0 0 1 2.71 2.711v2.8a2.713 2.713 0 0 1-2.71 2.71h-5.375a2.713 2.713 0 0 1-2.71-2.71zm17.047-87.64a90.068 90.068 0 0 0 29.319 5 90.053 90.053 0 0 0 29.318-5 12.484 12.484 0 0 0 8.439-11.813v-6.982a3.483 3.483 0 0 0-3.482-3.482H72.771a3.483 3.483 0 0 0-3.482 3.482v6.982a12.489 12.489 0 0 0 8.435 11.813zm-1.471-15.313h61.58v3.5a5.523 5.523 0 0 1-3.729 5.225 81.669 81.669 0 0 1-54.122 0 5.521 5.521 0 0 1-3.729-5.224zm212.191-10.579a30.319 30.319 0 0 0-41.332-28.23 3.482 3.482 0 1 0 2.537 6.486A23.342 23.342 0 1 1 234.8 52.152a23.539 23.539 0 0 1 .48-4.736 3.481 3.481 0 0 0-6.82-1.4 30.3 30.3 0 1 0 59.981 6.138z",
    className: "color3c3e4f svgShape"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M237.768 38.189a3.474 3.474 0 0 0 2.638-1.207l.1-.121a3.481 3.481 0 1 0-5.221-4.607l-.121.14 2.6 2.313-2.637-2.274a3.481 3.481 0 0 0 2.635 5.756Z",
    className: "color3c3e4f svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterHeaterIcon);
export default __webpack_public_path__ + "static/media/water-heater-icon.43992860e747fb8734be127dd857a5c3.svg";
export { ForwardRef as ReactComponent };